/* eslint-disable */
import KeenSlider from 'keen-slider'; 

export default function initStatsBlock() {
    
    const sections = document.querySelectorAll('.stats-block');
    
    const initPhotoStatsBlock = function( section ) {
        const cardList = section.querySelector('.cards-list');
        // duplicate cardlist for mobile
        const mobileCardList = cardList.cloneNode(true);
        mobileCardList.classList.add('mobile-card-list' , 'd-lg-none');
        cardList.classList.add('d-none', 'd-lg-grid');
        cardList.parentNode.appendChild(mobileCardList);
        
        const cards = mobileCardList.querySelectorAll('.card');

        const options = {
            selector: cards,
            defaultAnimation: {
                duration: 1000,
            },
            slides: {
                origin: 'auto',
                perView: 1.2,
                spacing: 10,
            },
            slidesPerView: 1,
            drag: true,
            loop: false,
            renderMode: 'precision',
            rubberband: false,
            centered: false,
        };

        const cardCarousel = new KeenSlider( mobileCardList ,
            options, [
                (carousel) => {
            },
        ] );
    }


    if ( sections ) {
        sections.forEach( (section) => {

            if (section.classList.contains('stats-photo-block') ) {
                initPhotoStatsBlock( section );
            }
            
        }); 
    }

}
